import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./PhoneInput.scss";

const PhoneFormInput = ({
  label,
  divClassName,
  name,
  value,
  handleBlur,
  error,
  touched,
  setFieldValue,
  placeholder,
  inputClass,
  errorClass,
  labelClass,
  containerClass,
  buttonClass,
  inputStyle,
  buttonStyle,
  ...rest
}) => {
  const [dialCode, setDialCode] = React.useState("61");

  const handleInputChange = (phoneNumber, data) => {
    if (data && data.dialCode) {
      setDialCode(data.dialCode);
    }
    setFieldValue(name, phoneNumber);
  };

  return (
    <div className={divClassName}>
      {label && (
        <p className={`${labelClass || "mb-2 text-sm font-medium text-gray-700"}`}>
          {label}
        </p>
      )}
      <div className="relative">
        <PhoneInput
          country={"au"}
          value={value}
          onChange={handleInputChange}
          onBlur={handleBlur}
          enableSearch={false}
          disableSearchIcon={true}
          disableCountryCode={true}
          inputProps={{
            name: name,
            ...rest
          }}
          placeholder={placeholder || "Contact Number"}
          containerClass={`react-tel-input ${containerClass || ""}`}
          inputClass={inputClass || "form-control"}
          buttonClass={buttonClass || "flag-dropdown"}
          dropdownClass="country-list"
          inputStyle={{
            ...inputStyle
          }}
          buttonStyle={buttonStyle}
        />
      </div>
      {error && touched ? (
        <span className={errorClass || "text-red-600 text-[10px] sm:text-[10px] md:text-[12px] font-[600] ms-1 mt-1 block"}>
          {error}
        </span>
      ) : null}
    </div>
  );
};

export default PhoneFormInput;
